<template>
    <div class="w-full">
        <table class=" table-auto overflow-x-scroll w-full my-4">
            <thead>
            <tr class="text-left text-black border">
                <th class="w-fit text-nowrap px-2 h-16">#</th>
                <th class="w-fit text-nowrap px-2 h-16">Buyurtma vaqti</th>
                <th class="w-fit text-nowrap px-2 h-16">Yuborilgan vaqti</th>
                <th class="w-fit text-nowrap px-2 h-16">Manzil</th>
                <th class="w-fit text-nowrap px-2 h-16">Status</th>
                <th class="w-fit text-nowrap px-2 h-16">Yetkazilgan vaqti</th>
                <th class="w-fit text-nowrap px-2 h-16">Summa</th>
            </tr>
            </thead>
            <tbody v-for="(order, index) in orders" :key="order.id" class="text-[#3F3D56]">
            <tr class="text-left border">
                <td class="w-fit text-nowrap px-2 h-16">{{ index + 1 }}</td>
                <td class="w-fit text-nowrap px-2 h-16">
                    <div class="flex flex-col">
                        <time class="text-lg text-stone-950">{{ dateTimeFormat(order.createdAt) }}</time>
                        <div class="text-xs text-zinc-500">{{ getTimeDifference(order.createdAt) }} oldin</div>
                    </div>
                </td>
                <td class="w-fit text-nowrap px-2 h-16">
                    <div class="flex flex-col" v-if="order.acceptedAt">
                        <time class="text-lg text-stone-950">{{ dateTimeFormat(order.acceptedAt) }}</time>
                        <div class="text-xs text-zinc-500">{{ getTimeDifference(order.acceptedAt) }} oldin</div>
                    </div>
                    <div class="flex flex-col" v-else>
                        -
                    </div>
                </td>
                <td class="w-fit text-nowrap px-2 h-16">
                    <div class="flex gap-5 mt-4">
                        <div class="flex">
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <ellipse cx="7.95048" cy="17" rx="2.0026" ry="2" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <ellipse cx="17.9635" cy="17" rx="2.0026" ry="2" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M5.94791 18C6.5002 18 6.94791 17.5523 6.94791 17C6.94791 16.4477 6.5002 16 5.94791 16V18ZM3.94531 17H2.94531C2.94531 17.5523 3.39303 18 3.94531 18V17ZM13.9583 5H14.9583C14.9583 4.44772 14.5106 4 13.9583 4V5ZM12.9583 17C12.9583 17.5523 13.406 18 13.9583 18C14.5106 18 14.9583 17.5523 14.9583 17H12.9583ZM9.95312 16C9.40084 16 8.95312 16.4477 8.95312 17C8.95312 17.5523 9.40084 18 9.95312 18V16ZM15.9609 18C16.5132 18 16.9609 17.5523 16.9609 17C16.9609 16.4477 16.5132 16 15.9609 16V18ZM19.9661 16C19.4138 16 18.9661 16.4477 18.9661 17C18.9661 17.5523 19.4138 18 19.9661 18V16ZM21.9687 17V18C22.521 18 22.9687 17.5523 22.9687 17H21.9687ZM21.9687 11H22.9687C22.9687 10.4477 22.521 10 21.9687 10V11ZM13.9583 10C13.406 10 12.9583 10.4477 12.9583 11C12.9583 11.5523 13.406 12 13.9583 12V10ZM13.9583 5C13.406 5 12.9583 5.44772 12.9583 6C12.9583 6.55228 13.406 7 13.9583 7V5ZM18.9648 6L19.822 5.48501C19.6412 5.18409 19.3159 5 18.9648 5V6ZM21.1115 11.515C21.396 11.9884 22.0103 12.1416 22.4837 11.8572C22.9571 11.5728 23.1104 10.9584 22.8259 10.485L21.1115 11.515ZM5.94791 16H3.94531V18H5.94791V16ZM4.94531 17V6H2.94531V17H4.94531ZM4.94531 6C4.94531 5.99878 4.94542 5.99862 4.9453 5.99919C4.9452 5.9997 4.94502 6.00027 4.94482 6.00074C4.94448 6.00155 4.94445 6.00124 4.94523 6.00046C4.94602 5.99967 4.94646 5.99957 4.94598 5.99977C4.94568 5.9999 4.94532 6.00001 4.94504 6.00007C4.94471 6.00013 4.94512 6 4.94661 6V4C3.84255 4 2.94531 4.8942 2.94531 6H4.94531ZM4.94661 6H13.9583V4H4.94661V6ZM12.9583 5V17H14.9583V5H12.9583ZM9.95312 18H15.9609V16H9.95312V18ZM19.9661 18H21.9687V16H19.9661V18ZM22.9687 17V11H20.9687V17H22.9687ZM21.9687 10H13.9583V12H21.9687V10ZM13.9583 7H18.9648V5H13.9583V7ZM18.1076 6.51499L21.1115 11.515L22.8259 10.485L19.822 5.48501L18.1076 6.51499Z" fill="black"/>
                            </svg>
                        </div>
                        <address class="flex-auto text-lg text-stone-950">
                            {{ order.address }}
                        </address>
                    </div>
                </td>
                <td class="w-fit text-nowrap px-2 h-16">
                    <div class="flex flex-col self-stretch">
                        <div class="text-lg font-medium" :class="order.deliveredAt ? 'text-green-500' : 'text-red-600'">
                            {{ order.deliveredAt ? 'Yetkazildi' : 'Rad etildi' }}
                        </div>
                    </div>
                </td>
                <td class="w-fit text-nowrap px-2 h-16">
                    <div class="flex flex-col" v-if="order.deliveredAt">
                        <time class="text-lg text-stone-950">{{ dateTimeFormat(order.deliveredAt) }}</time>
                    </div>
                    <div class="flex flex-col" v-else>
                        -
                    </div>
                </td>
                <td class="w-fit text-nowrap px-2 h-16">
                    <div class="flex mt-2">
                        <div class="flex-auto self-start text-lg text-stone-950">
                            {{ formattedSum(order.allPriceInUZS.toFixed(0)) }} UZS
                        </div>
                        <div
                            @click="updateCollapsedTR(order.id)"
                            class="flex justify-center items-center my-auto m-3 cursor-pointer hover:bg-gray-400 hover:text-white w-8 h-8 rounded-full"
                            :class="{'detail': activeCollapsedTR === order.id}"
                        >
                            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.999999 13L6.5 7L1 1" stroke="#6539B2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </td>
            </tr>
            <template v-if="activeCollapsedTR === order.id">
                <tr
                    v-for="product of order.productOrders"
                    :key="product.id"
                    class="text-left border bg-grayForTable"
                >
                    <td colspan="3" class="w-fit text-nowrap px-2">
                        <div>
                            <p class="font-semibold text-sm">Mijoz:</p>
                            <p class="text-sm m-0">{{ order.givenName }} {{ order.givenName }}</p>
                            <p class="text-sm">{{ order.phone }}</p>
                        </div>
                    </td>
                    <td class="w-fit text-nowrap px-2 h-16">
                        <p class="text-sm font-semibold">Maxsulot nomi:</p>
                        <p class="text-sm m-0">{{ product.productName }}</p>
                    </td>
                    <td class="w-fit text-nowrap px-2 h-16">
                        <p class="text-sm font-semibold">Kuryer:</p>
                        <p class="text-sm m-0">{{ order.kuryer ? order.kuryer : '-' }}</p>
                    </td>
                    <td class="w-fit text-nowrap px-2 h-auto">
                        <div class="flex gap-8 justify-center">
                            <div>
                                <p class="text-sm font-semibold">Omborda mavjud:</p>
                                <p class="text-sm m-0">{{ product.remainingProduct }} {{ product.unitOfMeasure ? $t('unitOfMeasure.' + product.unitOfMeasure) : '' }}</p>
                            </div>
                            <div>
                                <p class="text-sm font-semibold">Miqdor:</p>
                                <p class="text-sm m-0">{{ product.amount }} {{ product.unitOfMeasure ? $t('unitOfMeasure.' + product.unitOfMeasure) : '' }}</p>
                            </div>
                            <div>
                                <p class="text-sm font-semibold">Narxi:</p>
                                <p class="text-sm m-0">{{ formattedSum(product.sellingPrice) }} {{ product.currencyName }}</p>
                            </div>
                        </div>
                    </td>
                    <td class="text-nowrap px-2">
                        <p class="text-sm font-semibold">Summa:</p>
                        <p class="text-sm m-0">{{ formattedSum(product.totalPrice) }} {{ product.currencyName }}</p>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import formattedSum from "@/mixin/formattedSum";

export default {
    name: "ListOrdersArchives",
    props: {
        orders: {
            type: Array,
            required: true
        },
    },
    mixins: [dateFormattingMixin, formattedSum],
    data() {
        return {
            activeCollapsedTR: null
        }
    },
    methods: {
        getTimeDifference(time) {
            let difference = new Date() - new Date(time);
            let differenceInSeconds = difference / 1000;
            let differenceInMinutes = Math.floor(differenceInSeconds / 60);
            let differenceInHours = Math.floor(differenceInSeconds / 3600);
            let differenceInDays = Math.floor(differenceInSeconds / (3600 * 24));

            if (differenceInDays) {
                return differenceInDays + ' kun'
            } else if (differenceInHours) {
                return differenceInHours + ' soat'
            } else {
                return differenceInMinutes + ' min.'
            }

        },
        updateCollapsedTR(id) {
            this.activeCollapsedTR = this.activeCollapsedTR === id ? null : id
        },
    }
}
</script>

<style scoped>
.detail {
    transform: rotate(90deg);
}
</style>
